(() => {
  'use strict';
  const iso = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/;
  function campaigns(rows) {
    return rows.map(row => ({start: iso.test(row.start) ? Date.parse(row.start) : NaN, end: iso.test(row.end) ? Date.parse(row.end) : NaN}))
      .filter(row => Number.isFinite(row.start) && Number.isFinite(row.end) && row.end > row.start)
      .sort((a,b) => a.start - b.start);
  }
  function active(rows, now) { return rows.find(row => now >= row.start && now < row.end); }
  if (typeof module !== 'undefined' && module.exports) module.exports = {campaigns, active};
  if (typeof customElements === 'undefined' || customElements.get('brg-promo')) return;
  customElements.define('brg-promo', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.interval);
      try { this.rows = campaigns(JSON.parse(this.querySelector('[data-schedule]').textContent)); }
      catch (_) { this.hidden = true; return; }
      this.parts = ['days','hours','minutes','seconds'].map(key => this.querySelector('[data-' + key + ']'));
      this.tick = () => {
        const now = Date.now(), row = active(this.rows, now);
        this.hidden = !row;
        if (!row) return;
        const seconds = Math.ceil((row.end - now) / 1000);
        const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
        this.parts.forEach((part, i) => { const value = String(values[i]).padStart(2,'0'); if (part.textContent !== value) part.textContent = value; });
      };
      this.tick();
      this.interval = setInterval(this.tick, 1000);
      document.addEventListener('visibilitychange', this.tick);
    }
    disconnectedCallback() { clearInterval(this.interval); document.removeEventListener('visibilitychange', this.tick); }
  });
})();
